<template>
  <div class="GiftCardReminder__container">
    <a :href="giftCardPath" title="View Gift Cards">
      <!-- <span class="GiftCardReminder__img"></span> -->
      <img
        class="GiftCardReminder__img--desktop"
        title="Gift Cards Banner"
        alt="Gift Cards Banner"
        src="https://magazine.imgix.net/wysiwyg/GiftCard_Reminder_790x107.png?format=auto&w=790&h=107"
        width="790px"
        height="107px"
        loading="lazy"
      />
      <img
        class="GiftCardReminder__img--mobile"
        title="Gift Cards Banner"
        alt="Gift Cards Banner"
        src="https://magazine.imgix.net/wysiwyg/GiftCard_Reminder_Mobile.jpg?format=auto&w=430&h=145"
        width="430px"
        height="145px"
        loading="lazy"
      />
    </a>
  </div>
</template>
<script>
export default {
  name: 'GiftCardReminder',
  serverCacheKey() {
    return 'GiftCardReminder'
  },
  data() {
    return {}
  },
  computed: {
    giftCardPath() {
      // Check if the URL is already in the correct format
      if (this.$config.OptionsAddQueryStringToURLEnabled && this.$route.path.includes(this.$config.OptionsAddQueryStringToURLKey)) {
        return this.$route.path
      }
      // If not, construct the new URL with the query string
      let path = `/gift-card-options`
      if (this.$config.OptionsAddQueryStringToURLEnabled) {
        path = `/gift-card-options?${this.$config.OptionsAddQueryStringToURLKey}=${this.$config.OptionsAddQueryStringToURLValue}`
      }
      return path
    }
  }
}
</script>
<style lang="scss" scoped>
.GiftCardReminder {
  &__container {
    content-visibility: auto;
    display: block;
  }

  &__img {
    vertical-align: middle;
    border-style: none;

    &--desktop {
      display: none;
    }

    &--mobile {
      display: block;
      width: 100vw;
      height: auto;
      margin: 0 0 20px 0;
    }
  }
}

@media (min-width: $screen-sm-min) {
  .GiftCardReminder {
    &__container {
      display: flex;
      justify-content: center;
      flex-flow: row wrap;
      align-content: center;
    }

    &__img {
      flex: 100% 1 1;
      vertical-align: middle;
      border-style: none;

      &--desktop {
        display: block;
        width: 100vw;
        max-width: 790px;
        height: auto;
        margin: 20px;
      }

      &--mobile {
        display: none;
      }
    }
  }
}
</style>
